"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
// import { requestWorkspaceSelect } from '@app/request'
const util_1 = require("@app/util");
const _ui_1 = require("@ui");
const connect_1 = __importDefault(require("./connect"));
const MfaAuth_1 = require("@app/component/ui/mfa/MfaAuth");
const set_me_1 = __importDefault(require("@app/action/set-me"));
const store_1 = require("@app/store");
const new_mfa_factor_1 = __importDefault(require("@app/ac/new-mfa-factor"));
const ac_1 = require("@app/ac");
const verify_mfa_factor_1 = __importDefault(require("@app/ac/verify-mfa-factor"));
const SetupMFA = ({ mode, sendMfaFactor, shouldSendOnLoad, type, noClose, close, }) => {
    const { ws, me } = (0, store_1.useRootSelector)(({ workspaces, workspaceId, me }) => ({
        ws: workspaces.find(w => w.id === workspaceId),
        me: me,
    }));
    const [method, setMethod] = react_1.default.useState(null);
    const [code, setCode] = react_1.default.useState();
    const [totpRes, setTotpRes] = react_1.default.useState(null);
    const [sent, setSent] = react_1.default.useState(false);
    const [param, setParam] = react_1.default.useState('');
    const [isLoading, setLoading] = react_1.default.useState(false);
    const dispatch = (0, store_1.useRootDispatch)();
    const alreadyEnabledMethods = me?.mfa?.factors?.filter((f) => f.verified).map((f) => f.type);
    const allFactorsVerified = me?.mfa?.factors?.every((f) => f.verified);
    const wsMethods = ws?.settings?.mfa?.allowedMethods;
    const options = MfaAuth_1.allMethods.filter((m) => wsMethods?.includes(m) && !alreadyEnabledMethods.includes(m));
    react_1.default.useEffect(() => {
        if (mode === 'verify') {
            setSent(true);
        }
    }, [mode]);
    react_1.default.useEffect(() => {
        if (type) {
            setMethod(type);
        }
    }, [type]);
    const createFactor = react_1.default.useCallback(async () => {
        // "deep copy" of me to avoid state mutation
        const newMe = Object.assign({}, me, { mfa: { factors: [...me.mfa.factors], enabled: me.mfa.enabled } });
        let p = param;
        if (method === 'sms') {
            p = '+' + p.replace('-', '');
        }
        setLoading(true);
        const res = await dispatch((0, new_mfa_factor_1.default)({
            type: method,
            factorName: method === 'totp' ? me.email : method?.toString(),
            param: p,
        }));
        setLoading(false);
        if (method === 'totp') {
            setTotpRes(res);
        }
        if (res.type === method) {
            setSent(true);
            newMe.mfa.factors.push({ ...res, name: null, verified: false });
            dispatch((0, set_me_1.default)(newMe));
        }
    }, [me, param, method, setLoading, setSent, setTotpRes, dispatch]);
    const verifyFactor = react_1.default.useCallback(async () => {
        // "deep copy" of me to avoid state mutation
        const newMe = Object.assign({}, me, { mfa: { factors: [...me.mfa.factors], enabled: me.mfa.enabled } });
        if ((0, util_1.isUndefined)(code))
            return;
        setLoading(true);
        const success = await dispatch((0, verify_mfa_factor_1.default)({
            type: method,
            code,
        }));
        setLoading(false);
        if (success) {
            newMe.mfa.factors = newMe.mfa.factors.map((f) => {
                if (f.type === method) {
                    return { ...f, verified: true };
                }
                return f;
            });
            if (!me.mfa.enabled) {
                newMe.mfa.enabled = true;
            }
            dispatch((0, set_me_1.default)(newMe));
            if (mode === 'setup') {
                await dispatch((0, ac_1.setModal)('setup-mfa'));
                await dispatch((0, ac_1.setModal)(null));
            }
            if ((0, util_1.isDefined)(close)) {
                close();
            }
            else {
                await dispatch((0, ac_1.setModal)('setup-mfa'));
                await dispatch((0, ac_1.setModal)(null));
            }
        }
        else {
            setCode(undefined);
            util_1.notification.error({ code: null, message: 'WRONG_CODE' });
        }
    }, [me, mode, method, code, dispatch, setCode, setLoading]);
    react_1.default.useEffect(() => {
        if ((0, util_1.isUndefined)(code))
            return;
        const action = async () => {
            if (code.length === 6) {
                await verifyFactor();
            }
        };
        void action();
    }, [code, verifyFactor]);
    if (!options.length && allFactorsVerified) {
        return (react_1.default.createElement(_ui_1.Modal, { size: _ui_1.Modal.SIZES.S, isLoading: isLoading, headerContent: react_1.default.createElement("div", { className: 'ds-title' }, (0, util_1.t)('MFA_SETTINGS')), displayCloseButton: false, sections: [
                react_1.default.createElement(_ui_1.Text, { key: "mfa-all-available-methods", type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.BOLD }, (0, util_1.t)('MFA_ALL_AVAILABLE_METHODS_USED')),
            ], footerContent: react_1.default.createElement(_ui_1.Button, { onClick: async () => {
                    await dispatch((0, ac_1.setModal)(null));
                }, size: _ui_1.Button.SIZES.LARGE, style: _ui_1.Button.STYLES.CONTAINED, label: (0, util_1.t)('CLOSE') }) }));
    }
    return (react_1.default.createElement(_ui_1.Modal, { size: _ui_1.Modal.SIZES.M, isLoading: isLoading, headerContent: !sent ? react_1.default.createElement("div", { className: 'ds-title' }, (0, util_1.t)('MFA_SETTINGS'))
            : react_1.default.createElement("div", { className: 'ds-title' }, (0, util_1.t)('MFA_METHOD_VERIFICATION')), displayCloseButton: false, sections: [
            react_1.default.createElement(MfaAuth_1.MfaAuth, { mode: mode, options: options, key: 0, totpRes: totpRes, sent: sent, email: me?.email, telephone: me?.telephone, code: code, setCode: setCode, method: method, setMethod: setMethod, sendMfaFactor: sendMfaFactor, shouldSendOnLoad: shouldSendOnLoad, authParam: setParam }),
        ], footerContent: react_1.default.createElement(react_1.default.Fragment, null,
            !sent && (react_1.default.createElement(_ui_1.Button, { onClick: () => {
                    void dispatch((0, ac_1.logout)(true));
                }, size: _ui_1.Button.SIZES.LARGE, style: _ui_1.Button.STYLES.OUTLINED, label: (0, util_1.t)('LOGOUT') })),
            (sent || !noClose) && (react_1.default.createElement(_ui_1.Button, { onClick: async () => {
                    if (sent) {
                        setSent(false);
                    }
                    else {
                        if ((0, util_1.isDefined)(close)) {
                            close();
                            return;
                        }
                        await dispatch((0, ac_1.setModal)('setup-mfa'));
                        await dispatch((0, ac_1.setModal)(null));
                    }
                }, size: _ui_1.Button.SIZES.LARGE, style: _ui_1.Button.STYLES.OUTLINED, label: (0, util_1.t)('BACK') })),
            react_1.default.createElement(_ui_1.Button, { disabled: isLoading || !method || (sent && !code), onClick: createFactor, size: _ui_1.Button.SIZES.LARGE, style: _ui_1.Button.STYLES.CONTAINED, loading: isLoading, label: sent ? (0, util_1.t)('VERIFY') : (0, util_1.t)('SETUP') })) }));
};
exports.default = (0, connect_1.default)(SetupMFA);
